import {
  Component,
  ChangeDetectionStrategy,
  ContentChild,
  OnInit,
  ChangeDetectorRef,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  Compiler,
  Injector,
  NgModuleRef,
  NgModule
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormControlToken } from '../../shared/constants/form-control-token';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GeoModule } from '../../geo/geo.module';

@Component({
  selector: 'app-control-squeeze',
  template: `<div>
                      <div  class="app-control-squeeze-value"
                      [style.display]="squeezeValueVisible ? 'block' : 'none'"
                            (click)="toggleSqueezedValue($event)">
                        <div #dynamicComponent></div>
                      </div>
                      <div [style.display]="!squeezeValueVisible ? 'block' : 'none'" (appClickOutside)="toggleSqueezedValue($event)">
                        <ng-content></ng-content>
                      </div>
                    </div>`,
  styles: [`
                      .app-control-squeeze-value {
                        display: flex;
                        align-items: center;
                        background-color: #f5fafd;
                        border: 1px solid #d9dfe7;
                        border-radius: 3px;
                        cursor: pointer;
                        min-height: 32px;
                        font-size: 1.4rem;
                        padding: 5px;
                        box-sizing: border-box;
                      }
                    `],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: ControlSqueezeComponent,
    multi: true
  }],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ControlSqueezeComponent implements OnInit, OnDestroy {
  @ViewChild('dynamicComponent', { read: ViewContainerRef }) _container: ViewContainerRef;
  private cmpRef;

  destroy$ = new Subject();
  squeezeValueVisible = true;

  squeezedValue;

  @ContentChild(FormControlToken) control;

  toggleSqueezedValue(event) {
    event.stopPropagation();
    this.squeezeValueVisible = !this.squeezeValueVisible;
    // Focus inner control
    if (!this.squeezeValueVisible) {
      this.control.focus();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    //Always destroy the dynamic component
    //when the parent component gets destroyed
    if (this.cmpRef) {
      this.cmpRef.destroy();
    }
  }

  private addComponent(template) {
    @Component({
      template: template
    })
    class DynamicComponent {
      constructor() { }
    }
    @NgModule({
      imports: [
        BrowserModule,
        GeoModule
      ],
      declarations: [DynamicComponent]
    })
    class DynamicComponentModule { }

    const mod = this.compiler.compileModuleAndAllComponentsSync(DynamicComponentModule);
    const factory = mod.componentFactories.find((comp) =>
      comp.componentType === DynamicComponent
    );
    this._container.clear();
    const component = this._container.createComponent(factory);
  }

  ngOnInit() {
    this.control.squeezedValue$
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe((squeezedValue) => {
        setTimeout(() => {
          this.squeezedValue = squeezedValue;
          this.addComponent(this.squeezedValue);
          this.changeDetectorRef.markForCheck();
          this.changeDetectorRef.detectChanges();
        });
      });
  }

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private compiler: Compiler,
    private _injector: Injector,
    private _m: NgModuleRef<any>) { }
}
